import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the BuyitemPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-buyitem',
  templateUrl: 'buyitem.html',
})
export class BuyitemPage {
    loginId: string;
	email: string;
	jikgeup: string;
    api_key: string;
    version: string;

    list: any = [];
    // productA: any = [];
    // productB: any = [];
    // productC: any = [];
	// completed_list: any = [];
	// pending_list: any = [];
    // params: any[] = [];
    // count: number = 0;
    // max_length: number = 0;
    
	coin_unit: string;
    
    total: string;
    value: string;

	texts: any = [];
    language : string;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        // private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
		// this.wallet_address = navParams.get("wallet_address");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "apply");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.jikgeup = localStorage.getItem("jikgeup");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).buy_items;
	}

    _cancel(idx){
		let alert = this.alertCtrl.create({
			message: this.texts.alertM_cancel,
			buttons: [
				{
					text: this.texts.no_btn
				},
				{
					text: this.texts.ok_btn,
					handler: () => {
						let body = JSON.stringify({
                            api: this.api_key,
                            language: this.language,
                            version: this.version,
							idx: idx
						});
						this.http.post("deposit/base/index/delete", body).then((res: any) => {
							if(res.result === "OK"){
                                this._init();

							} else if(res.result ==="RELOAD"){
								let alert = this.alertCtrl.create({
									message: res.message,
									buttons: ['OK']
								});
								alert.present();
								this._init();

							} else {
								let alert = this.alertCtrl.create({
									message: res.message,
									buttons: ['OK']
								});
								alert.present();
							}
						},(err)=>{	
							//// HTTP 에러인 경우
							let alert = this.alertCtrl.create({
								message: err,
								buttons: ['OK']
							});
							alert.present();
						
						});
					}
				}
			]
		});
		alert.present();
    }

    _save(code) {
        let url = "deposit/base/index/save";
        let body = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            product: code
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();

                this._init();

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        },(err)=>{
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
        
        });
        
    }

	_init() {

		let url = "deposit/base";
		let body = JSON.stringify({ 
			api: this.api_key,
			language: this.language,
			version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                if (res.list != undefined) {   
                    this.list = res.list;
                }
                // this.productA = res.product.A;
                // this.productB = res.product.B;
                // this.productC = res.product.C;

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}
        

	// loginId: string;
	// id: string;
	// api_key: string;
	// email: string;
	// version: string;
	// jikgeup: string;
	// cash_unit: string;
	
    // unit_price: string;
    // total: string;
    // max: string;
	// list: any = [];
	// max_items: number = 0; 
	// count_items: number = 0;

    // value: string = "";

	// texts: any = [];
	// language: string;

    // isButton : boolean = true;

	// constructor(
	// 	public navCtrl: NavController,
	// 	public navParams: NavParams,
	// 	public modalCtrl: ModalController,
	// 	public alertCtrl: AlertController,
	// 	public toastCtrl: ToastController,
	// 	private http: HttpService,
	// 	public app: App
	// ) {

	// }

	// ionViewWillEnter() {

	// 	//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
	// 	this.api_key = localStorage.getItem("api_key");
	// 	this.loginId = localStorage.getItem("loginId");
	// 	this.id = localStorage.getItem("id");
	// 	if(!this.api_key) {
	// 		this.app.getRootNav().setRoot(LoginPage);
	// 	}
	// 	localStorage.setItem('point_unit', 'POINT');

	// 	//// 페이지 이름
    //     localStorage.setItem("pageName", "buy_items");
    //     this.language = localStorage.getItem("language");
    //     this.email = localStorage.getItem("email");
    //     this.version = localStorage.getItem("version");
        
    //     this.jikgeup = localStorage.getItem("jikgeup");
    //     this.cash_unit = localStorage.getItem("cash_unit");

    //     this._get_texts();
		
	// 	this._init();
	// }

	// _get_texts() {
	// 	this.texts = JSON.parse(localStorage.getItem('lang_pack')).buy_items;
	// }

    // keyDown(event) {
	// 	if (this.value == undefined || this.value == null) {
	// 		var tmps: string = "";
	// 	} else {
	// 		tmps = this.value;
	// 	}
		
	// 	this.value = tmps.replace(/[^0-9]/g, "");
	// 	let pattern = /^[0-9]/g;		
	// 	if (pattern.test(tmps)) {
	// 		if (event.keyCode == 110 || event.keyCode == 190) {
	// 			return false;
	// 		}
	// 	}
		

    // }

    // keyUp() {
    //     if(this.value != null || this.value != "") {

    //     } else {

    //     }
        
	// }
	
	// _buy_item() {
    //     this.isButton = false;

    //     if (!this.value || this.value.length == 0 || this.value =="0") {
	// 		const toast = this.toastCtrl.create({
	// 			message:  this.texts.toastM_amount,
	// 			duration: 2000,
	// 			position: 'middle'
	// 		});
    //         toast.present();
    //         this.isButton = true;
	// 		return false;
	// 	}

    //     let url = "lucky/base/index/save";
	// 	let body = JSON.stringify({ 
	// 		api: this.api_key,
	// 		language: this.language,
	// 		version: this.version,
    //         value: this.value
	// 	});
	// 	this.http.post(url, body).then((res: any) => {
	// 		if(res.result=="OK"){
    //             let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
    //             this.value = "";
    //             this.isButton = true;
    //             this._list();

	// 		} else if(res.result ==="LOGOUT"){
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
    //             this.value = "";
    //             this.isButton = true;

	// 			localStorage.removeItem("loginId");
	// 			localStorage.removeItem("api_key");
	// 			this.app.getRootNav().setRoot(LoginPage);
			
	// 		} else {
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
    //             this.value = "";
    //             this.isButton = true;
	// 		}
	// 	},(err)=>{
	// 		//// HTTP 에러인 경우
	// 		let alert = this.alertCtrl.create({
	// 			message: this.texts.alertM_err,
	// 			buttons: ['OK']
	// 		});
	// 		alert.present();
    //         this.value = "";
    //         this.isButton = true;
		
	// 	});
		
	// }

	// _init() {
    //     this.value = "";

	// 	let url = "lucky/base";
	// 	let body = JSON.stringify({ 
	// 		api: this.api_key,
	// 		language: this.language,
	// 		version: this.version
	// 	});
	// 	this.http.post(url, body).then((res: any) => {
	// 		if(res.result=="OK"){
    //             this.unit_price = res.unit_price;
    //             this.total = res.total;
    //             this.max = res.max;

	// 			if (res.list != undefined) {   
    //                 this.list = res.list;
    //             }

	// 		} else if(res.result ==="LOGOUT"){
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
	// 			localStorage.removeItem("loginId");
	// 			localStorage.removeItem("api_key");
	// 			this.app.getRootNav().setRoot(LoginPage);
			
	// 		} else {
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
	// 		}
	// 	},(err)=>{
	// 		//// HTTP 에러인 경우
	// 		let alert = this.alertCtrl.create({
	// 			message: this.texts.alertM_err,
	// 			buttons: ['OK']
	// 		});
	// 		alert.present();
		
	// 	});
	// }

    // _list() {
    //     this.navCtrl.push(ItemshistoryPage);
    // }

}



// WEBPACK FOOTER //
// ./src/pages/buyitem/buyitem.ts